import { useCallback, useMemo } from 'react'
import { useShopify } from '@/hooks/useShopify'
import { useQueryFlags } from './useQueryFlags'

export const useFeatureFlags = () => {
  const { featureFlags: baseFeatureFlags } = useShopify()

  const featureFlags = useMemo(() => baseFeatureFlags || {}, [baseFeatureFlags])

  const { queryFlags } = useQueryFlags()

  const getFlag = useCallback(
    (flag: string): boolean => {
      if (featureFlags?.[flag] || queryFlags.includes(flag)) {
        return true
      }
      return false
    },
    [featureFlags, queryFlags],
  )

  return { getFlag }
}
